import type { admin_directory_v1, chromemanagement_v1 } from 'googleapis';
import { Vendors } from '../vendor.enum';
import { BaseAsset } from './base-asset.interface';

export class GoogleDeviceData {
  activeTimeRanges?: Array<{activeTime?: number; date?: string}>;
  annotatedAssetId?: string;
  annotatedLocation?: string;
  annotatedUser?: string;
  architecture?: string;
  autoUpdateExpiration?: Date | string | number;
  autoUpdateThrough?: string;
  availableBytes?: string;
  availableDiskBytes?: string;
  availableMemoryBytes?: string;
  batteryHealth?: string;
  batteryHealthPercentage?: number;
  batteryType?: string;
  bootMode?: string;
  bootTime?: string;
  capacityBytes?: string;
  cpuUtilizationPct?: number;
  customerId?: string;
  designCapacityMah?: number;
  diskAvailable?: string;
  diskTotal?: string;
  diskUsed?: string;
  diskUsedCategory?: string;
  display?: { resolution?: string; refreshRate?: number }[];
  driverVersion?: string;
  firmwareVersion?: string;
  firstEnrollmentTime?: Date | string | number;
  fullChargeCapacity?: number;
  fullChargeCapacityMah?: number;
  gateway?: string;
  gatewayIpAddress?: string;
  ipAddress?: string;
  lanIpAddress?: string;
  lastEnrollmentTime?: Date | string | number;
  lastKnownUser?: string;
  lastRebootTime?: Date | string | number;
  lastReportedBatteryUsage?: string;
  lastStableChromeVersion?: string;
  // TODO: Do we need all the last fields (lastSync and lastUpdated), and should they be Dates or strings or either?
  lastSync?: Date | string | number;
  lastUpdateCheckTime?: Date | string | number;
  lastUpdated?: Date | string | number;
  macAddress?: { wifi?: string; ethernet?: string };
  maxClockSpeedKhz?: number;
  maximumDomainAllowedChromeVersion?: string;
  model?: string;
  notes?: string;
  orgUnitId?: string;
  orgUnitPath?: string;
  osVersion?: string;
  platformVersion?: string;
  powerSource?: string;
  readBytesPerSecond?: string;
  recentUsers?: Array<{email?: string; type?: string}>;
  signalStrengthDbm?: number;
  status?: string;
  storageName?: string;
  systemRamTotal?: string;
  targetOsVersion?: string;
  /**
   * When this device's telemetry (battery, storage, memory, etc.) was last
   * written (ISO 8601). Carried over with the telemetry when a sync has none,
   * so it shows how old the telemetry is; lastAssetSync describes the
   * directory data.
   */
  telemetrySyncedAt?: string;
  temperatureCelsius?: number;
  totalBytes?: string;
  totalDiskBytes?: string;
  totalMemoryBytes?: string;
  type?: string;
  updateCheckTime?: string;
  voltageMillivolt?: number;
  writeBytesPerSecond?: string;
}

export class MicrosoftDeviceData {}

export class AppleDeviceData {}

export class VendorDeviceData {
  [Vendors.GOOGLE]?: GoogleDeviceData;
  [Vendors.MICROSOFT]?: MicrosoftDeviceData;
  [Vendors.APPLE]?: AppleDeviceData;
}

export interface GoogleRawVendorDeviceData {
  data: admin_directory_v1.Schema$ChromeOsDevice;
  telemetryData?: chromemanagement_v1.Schema$GoogleChromeManagementV1TelemetryDevice;
}

export type RawVendorDeviceData = {
  [Vendors.GOOGLE]?: GoogleRawVendorDeviceData;
  [Vendors.MICROSOFT]?: unknown;
  [Vendors.APPLE]?: unknown;
};

export class DeviceAsset extends BaseAsset {
  serialNumber!: string;
  make!: string;
  model!: string;
  osMajorVersion!: number;
  vendorProperties!: VendorDeviceData;
  rawVendorProperties!: RawVendorDeviceData;
}
